<template>
  <div class="overflow-transition-character">
    <transition name="character" mode="out-in" appear>
      <div :key="$route.params.project" class="character" :style="{'transition-delay': `${index * 15}ms`}" :class="{'space' : content === ' '}">
        {{content}}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'OverflowTransitionCharacter',
  props: {
    content: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
  },
  methods: {
    easing(t) {
      t = t >= 1 ? 1 : t;

      let value = t<.5 ? 2*t*t : -1+(4-2*t)*t;
      value = value >= 1 ? 1 : value;

      console.log(value);
      return value;
    }
  }
}
</script>

<style lang="scss">
.overflow-transition-character{
  .character {
    &.space {
      margin-left: 7px;
    }
  }

  .character-enter-active, .character-leave-active {
    transition: transform .5s var(--easing);
  }
  .character-enter {
    transform: translateY(-52px);
  }
  .character-leave-to {
    transform: translateY(52px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OverflowTransitionCharacter.vue